"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "20", height: "19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.844.137L.156.863 9.273 9.5.156 18.137l.688.726L10 10.189l9.156 8.674.688-.726L10.727 9.5 19.844.863l-.688-.726L10 8.811.844.137z", fill: "#91908D" }))); };
exports.default = Component;
//# sourceMappingURL=MobileClose.js.map